import { MFButton } from "../../../../common/components/MFButton";
import { MFCheckbox } from "../../../../common/components/MFCheckbox";
import MFModal from "../../../../common/containers/MFModal";

export function ModalArchiveCalcul({
  isOpen,
  onClose,
  archiveCalcul,
  dontShowCalculArchiveModal,
  setDontShowCalculArchiveModal,
}) {
  return (
    <MFModal isOpen={isOpen} onClose={onClose}>
      <p className="modal-title">Archiver un calcul</p>
      <p className="modal-text" style={{ marginBottom: "20px" }}>
        En archivant ce calcul, il sera supprimé de la vue “Tous mes calculs”
        <br /> ainsi que de tous les dossiers dans lequel il a pu être ajouté.
        <br />
        <br />
        Vous pouvez à tout moment restaurer un calcul archivé depuis le dossier
        “Archives”.
      </p>
      <div className="d-flex flex-column">
        <MFCheckbox
          checked={dontShowCalculArchiveModal}
          onChange={(e) => setDontShowCalculArchiveModal(e.target.checked)}
          label="Ne plus afficher ce message"
        />
      </div>
      <div className="d-flex align-items-center justify-content-end mt-2">
        <MFButton
          className="mr-1"
          style={{ fontSize: 15 }}
          cancelButton
          onClick={onClose}
        >
          Annuler
        </MFButton>
        <MFButton style={{ fontSize: 15 }} onClick={archiveCalcul}>
          Archiver le calcul
        </MFButton>
      </div>
    </MFModal>
  );
}
